import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import StatusContainer from "../../../_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../../_utils/FormatAmount/FormatAmount";

const ReimbursementRequestMultiApprovalDeclined = () => {
  const [declinedPageData, setdeclinedPageData] = useState([]);
  const [declinedPageID, setdeclinedPageID] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedReimbursementRequestTxnData"),
    );

    if (storedSelectedApproval) {
      setdeclinedPageData(storedSelectedApproval?.selectedSendTransactions);
      setdeclinedPageID(storedSelectedApproval?.selectedTransactions);
    } else {
      setdeclinedPageData([]);
      setdeclinedPageID([]);
    }
  }, []);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const buttonRows = [
    [
      {
        btnText: "Approve requests",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.APPROVE_MORE_TXN,
        imgColor: "var(--positive-bg)",
        handleFunction: () =>
          navigate(
            "/reimbursement_transaction_dashboard/reimbursement_request_multi_select",
            {
              replace: true,
            },
          ),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        hoverOption: "black",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () =>
          navigate("/reimbursement_transaction_dashboard", {
            replace: true,
          }),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "black",
      },
    ],
  ];

  const TransactionList = ({ transactions }) => (
    <div className="flex flex-col">
      {transactions?.map((account, i) => (
        <InfoCard
          key={i}
          bgColor="var(--positive-card)"
          hoverable="black"
          rowBorderColor={"var(--positive-bg)"}
          showRowDivider
          onClick={() =>
            navigate(
              `/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/${account?.request_id}`,
              {
                replace: true,
              },
            )
          }
          rows={[
            {
              // leftTitle: accountNameStandardised(
              //   account?.beneficiary_account_name,
              // ),
              // leftSubTitle: "Account name",

              leftTitle: (
                <>
                  INR{" "}
                  <FormatAmount
                    price={account?.requested_amount ?? account?.amount}
                  />
                </>
              ),
              leftTextFontWeight: "semibold",
              leftSubTitle: "Amount",
              rightTitleTextColor: "var(--text-primary)",
              rightTextFontWeight: "semibold",
              // hasRight: true,
              rightIcon: true,
              // rightText: true,
              onClick: () =>
                navigate(
                  `/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/${account?.request_id}`,
                  {
                    replace: true,
                  },
                ),
            },
            {
              leftTitle: account?.beneficiary_account_name,
              leftSubTitle: "Account name",

              rightTitle: (
                <>
                  INR{" "}
                  <FormatAmount
                    price={account?.requested_amount ?? account?.amount}
                  />
                </>
              ),
              rightSubTitle: "Amount",
              rightTitleTextColor: "var(--text-primary)",
              rightTextFontWeight: "semibold",
              // rightIcon: true,
              // rightText: true,
              onClick: () =>
                navigate(
                  `/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/${account?.request_id}`,
                  {
                    replace: true,
                  },
                ),
            },
          ]}
        />
      ))}
    </div>
  );

  return (
    <StatusContainer
      status="success"
      buttonRows={buttonRows}
      title={declinedPageID?.length && "Requests rejected successfully."}
    >
      <TabsWeapperSection
        title={`Rejected - ${
          declinedPageID?.length || declinedPageData?.length
        }`}
      >
        <TransactionList transactions={declinedPageData} />
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default ReimbursementRequestMultiApprovalDeclined;
